import {Injectable} from '@angular/core'
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router'
import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'
import {AuthHelperService} from '@app/core/services/auth-helper.service'
import {AuthenticationService} from '@app/core/services/authentication.service'

@Injectable()
export class AuthGuard {
  constructor(
    private auth: AuthenticationService,
    private helper: AuthHelperService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.auth.isAuthenticated().pipe(
      map((auth) => {
        if (!auth) {
          // not authenticated so redirect to login page
          this.helper.redirect(state.url)
          return false
        }
        return auth
      }),
    )
  }
}
